module.exports = __webpack_public_path__ + "static/media/arrow-right-long.308b4da7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/arrow-right-long.svg
// module id = 2388
// module chunks = 0